import { api, call } from './api.js';

/** May this person link barcodes? Admin + staff (maintainer ruling, 27 Sep 2026). `null` (whoami
 *  not landed yet) shows the controls — the app's convention: client roles RENDER, the server
 *  gates (`operateProcedure` + RLS `operate`) and refuses anyone else by name. One function for
 *  the scan screen and the item screen, so the two cannot draw the line in different places. */
export function canLinkBarcodes(role: string | null | undefined): boolean {
  return role === null || role === undefined || role === 'admin' || role === 'staff';
}

/**
 * THE TWO BARCODE WRITES (0.1.515), hoisted: the item screen, the barcode picker and "Link to new
 * item" all link, and the item screen unlinks — three call sites, one timeout, one ledger label.
 *
 * ⚠️ EVERY INTERACTIVE WRITE HAS A TIMEOUT (CLAUDE.md, G10), and the app's shared tRPC link does
 * not set one — a pre-existing gap recorded in the 0.1.515 CHANGELOG, not widened into this change.
 * These two carry their own signal, so a link made at a rack on a dead connection says so after
 * fifteen seconds instead of spinning forever. `call` classifies the abort (an AbortError /
 * TimeoutError is retryable by name, never by message), notifies, and writes the ledger.
 *
 * Online-only on purpose: neither procedure is queueable (catalog/barcodes.ts says why).
 */
export const BARCODE_WRITE_TIMEOUT_MS = 15_000;

export function linkBarcode(itemId: string, code: string) {
  return call('linkBarcode', () =>
    api.linkBarcode.mutate({ itemId, code }, { signal: AbortSignal.timeout(BARCODE_WRITE_TIMEOUT_MS) }),
  );
}

export function unlinkBarcode(itemId: string, code: string) {
  return call('unlinkBarcode', () =>
    api.unlinkBarcode.mutate({ itemId, code }, { signal: AbortSignal.timeout(BARCODE_WRITE_TIMEOUT_MS) }),
  );
}
